namespace GeniuzPOS.CustomReport {
    export class ReportCusSaleComparisonMonthColumns {
        static columnsKey = 'CustomReport.ReportCusSaleComparison';
    }
}
